var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M30.2 6.57 15.59 21.21a3.9 3.9 0 0 0 0 5.5l14.67 14.7a1.95 1.95 0 0 0 3.33-1.37 2 2 0 0 0-.57-1.38l-14.67-14.7L32.97 9.32a1.96 1.96 0 0 0-2.76-2.76v.01Z"
})));
export { SvgChevron as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/chevron.svg", import.meta.url).toString();